import { useSyncExternalStore } from 'react';

import useDelayedIndicator from '../hooks/useDelayedIndicator.hook';
import { isPartSwap, subscribeSwapState } from './editor/controller';

/** Clicking and waiting with no feedback reads as a dead click. False for the first load, which already has the "Edit draft" spinner. */
export const useShowPartLoading = (): boolean =>
  useDelayedIndicator(useSyncExternalStore(subscribeSwapState, isPartSwap));
